//tipos
import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { StateTipoEgresos } from "@/typings/store/plugins/easyFirestore/tipoEgresos";

const getters: GetterTree<StateTipoEgresos, State> = {
    get(state) {
        return state.all;
    },
    getArray(state) {
        return Object.values(state.all);
    },
};

const tipoEgresos = {
    firestorePath: "dev/v1/tipoEgresos",
    firestoreRefType: "collection",
    moduleName: "tipoEgresos",
    statePropName: "all",
    namespaced: true,
    serverChange: {
        convertTimestamps: {
            created_at: "%convertTimestamp%", // default
            updated_at: "%convertTimestamp%", // default
        },
    },
    state: {},
    getters,
    mutations: {},
    actions: {},
};

export default tipoEgresos;
